export type { TimezonesState } from './reducer';
export { timezonesReducer } from './reducer';
